import { render, staticRenderFns } from "./cebsbInfoData.vue?vue&type=template&id=74f4e0c2&scoped=true&"
import script from "./cebsbInfoData.vue?vue&type=script&lang=js&"
export * from "./cebsbInfoData.vue?vue&type=script&lang=js&"
import style0 from "./cebsbInfoData.vue?vue&type=style&index=0&id=74f4e0c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4e0c2",
  null
  
)

export default component.exports